export const imageValidation = function({imagesType, Yup, user}){
    let imageValid = {}
    imagesType.forEach( (item)=>{
        imageValid[item.name] = Yup.mixed()
        // .test('required', "You need to provide a file", (value, context) =>{
        //   if(user && !user?.[item.id] && typeof context.originalValue === 'object'){
        //       return value && value.length
        //   }else if(!user) {
        //       return value && value.length
        //   }else{
        //     return true
        //   }
        // })
        .test("fileSize",  "The file is too large", (value, context) => {
          console.log(context.originalValue)
          if(user && !user?.[item.id] && (typeof context.originalValue === "object" && context.originalValue.length > 0)){
            console.log("Test One")
              return value && value[0] && value[0]?.size <= 100000;
          }else if(!user &&  (typeof context.originalValue === "object" && context.originalValue.length > 0)) {
            console.log("Test Two")
              return value && value[0] && value[0]?.size <= 100000;
          }else{
            return true
          }
        })
        .test("type", "We only support jpeg", function (value, context) {
          if(user && !user?.[item.id] && (typeof context.originalValue === "object" && context.originalValue.length > 0)){
              return value && value[0] && ["image/jpeg", "image/png"].indexOf(value[0].type) > -1;
          }else if(!user &&  (typeof context.originalValue === "object" && context.originalValue.length > 0)) {
              return value && value[0] && ["image/jpeg", "image/png"].indexOf(value[0].type) > -1;
          }else{
            return true
          }
        })
    } )
    return imageValid
}